import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import jwt_decode from "jwt-decode";
import "./Dashboard.css";
import DashboardMain from "./DashboardMain/DashboardMain";
import DashboardNavigation from "./DashboardNavigation/DashboardNavigation";
import DashboardWrapper from "./DashboardSubComponent/DashboardWrapper/DashboardWrapper";
import Messages from "./DashboardSubComponent/Messages/Messages";
import Users from "./DashboardSubComponent/Users/Users";
import AddServices from "./DashboardSubComponent/AddServices/AddServices";
import Orders from "./DashboardSubComponent/Orders/Orders";
import UserOrder from "./DashboardUserSubComponent/UserOrder/UserOrder";
import GiveReview from "./DashboardUserSubComponent/GiveReview/GiveReview";
import Reviews from "./DashboardSubComponent/Reviews/Reviews";
import MakeAdmin from "./DashboardSubComponent/MakeAdmin/MakeAdmin";
const Dashboard = () => {
  const { routeName } = useParams();
  const [dToken, setDToken] = useState({});
  const [users, setUsers] = useState([]);
  const [messages, setMessages] = useState([]);
  const [orders, setOrders] = useState([]);
  const [reviews, setReviews] = useState([]);
  const token = JSON.parse(localStorage.getItem("user"));

  const decodeToken = async () => {
    try {
      const decodeToken = await jwt_decode(token?.token);
      setDToken(decodeToken);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => decodeToken(), [routeName]);

  useEffect(() => {
    axios
      .get("https://mysterious-sierra-48850.herokuapp.com/users", {
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token.token,
        },
      })
      .then((data) => {
        setUsers(data.data);
      })
      .catch((error) => {
        console.log(error.response);
      });
  }, [routeName === "users"]);

  useEffect(() => {
    console.log(routeName);
    // alert(routeName);
  }, [routeName]);

  useEffect(() => {
    axios
      .get("https://mysterious-sierra-48850.herokuapp.com/get-messages", {
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token.token,
        },
      })
      .then((data) => {
        setMessages(data.data);
      })
      .catch((error) => {
        console.log(error.response);
      });
  }, [routeName === "messages"]);

  useEffect(() => {
    axios
      .get("https://mysterious-sierra-48850.herokuapp.com/getOrders", {
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token.token,
        },
      })
      .then((data) => {
        setOrders(data.data);
      })
      .catch((error) => {
        console.log(error.response);
      });
  }, [routeName === "orders"]);

  useEffect(() => {
    axios
      .get("https://mysterious-sierra-48850.herokuapp.com/get-all-review", {
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token.token,
        },
      })
      .then((data) => {
        setReviews(data.data);
      })
      .catch((error) => {
        console.log(error.response);
      });
  }, [routeName === "reviews"]);

  return (
    <div className="dashboard_container">
      <DashboardNavigation dToken={dToken} />
      {(() => {
        switch (routeName) {
          case undefined:
            return (
              (dToken.role === "admin" && (
                <DashboardMain
                  users={users}
                  messages={messages}
                  orders={orders}
                  reviews={reviews}
                />
              )) || (
                <DashboardWrapper>
                  {dToken.role === "admin" ? (
                    <Orders orders={orders} />
                  ) : (
                    <UserOrder orders={orders} />
                  )}
                </DashboardWrapper>
              )
            );
          case "users":
            return (
              <DashboardWrapper>
                <Users users={users} />
              </DashboardWrapper>
            );
          case "messages":
            return (
              <DashboardWrapper>
                <Messages messages={messages} />
              </DashboardWrapper>
            );
          case "addServices":
            return (
              <DashboardWrapper>
                <AddServices messages={messages} />
              </DashboardWrapper>
            );
          case "giveReview":
            return (
              <DashboardWrapper>
                <GiveReview messages={messages} />
              </DashboardWrapper>
            );
          case "reviews":
            return (
              dToken.role === "admin" && (
                <DashboardWrapper>
                  <Reviews reviews={reviews} />
                </DashboardWrapper>
              )
            );
          case "makeAdmin":
            return (
              dToken.role === "admin" && (
                <DashboardWrapper>
                  <MakeAdmin token={token} />
                </DashboardWrapper>
              )
            );
          case "orders":
            return (
              <DashboardWrapper>
                {dToken.role === "admin" ? (
                  <Orders orders={orders} />
                ) : (
                  <UserOrder orders={orders} />
                )}
              </DashboardWrapper>
            );
          default:
            return <h1>Page not found</h1>;
        }
      })()}
    </div>
  );
};

export default Dashboard;
